module.exports = __webpack_public_path__ + "img/图1.8ac38598.jpg";